export default __webpack_public_path__ + "files/1_3_1_Draft_Bioeconomy_Strategy_Lviv_Region_Ukraine.docx";